(ns manage.adset-decision-tree-page.ad-variant-table-ocp.columns
  (:require [clojure.string :as str]))

(def cm360-field "placement-name")

(defn row-id [node-id uuid]
  (str node-id "--" uuid))

(def fixed-columns
  [{:field "clickTrackers" :type "click" :header "Click Tracker"
    :placeholder "Paste tracker URL..."}
   {:field "tagging" :type "tagging" :header "Tagging"
    :placeholder "utm_source=...&utm_medium=..."}
   {:field "pixel" :type "pixel" :header "Meta Pixel"
    :placeholder "Pixel ID"}
   {:field cm360-field :type "cm360" :header "CM360 Placement"
    :placeholder "Placement name"}])

(def normal-fixed-columns
  (filterv #(not= cm360-field (:field %)) fixed-columns))

(def fixed-column-types
  (into {} (map (juxt :field :type)) fixed-columns))

(def fixed-column-headers
  (into {} (map (juxt :field :header)) fixed-columns))

(def ^:private type->placeholder
  (into {} (map (juxt :type :placeholder)) fixed-columns))

(defn column-placeholder [type]
  (get type->placeholder type "Paste tracker URL..."))

(defn impression-field? [field]
  (str/starts-with? field "impressionTrackers-"))

(defn field->column-type [field]
  (if (impression-field? field) "impression" (fixed-column-types field)))

(defn impression-columns [columns]
  (filterv impression-field? columns))

(defn has-column? [columns field]
  (boolean (some #{field} columns)))

(defn initial-columns [initial-rows]
  (let [max-impression (->> initial-rows (map (comp count :impression-trackers)) (apply max 0))
        present? (fn [field] (some #(get % (keyword field)) initial-rows))]
    (into (mapv #(str "impressionTrackers-" %) (range max-impression))
          (filter present? (map :field normal-fixed-columns)))))
